import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|System Activity|Email History|Preview Modal|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.CandidateAccess,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateSystemActivityEmailHistoryPreviewModal';
export type SPCandidateSystemActivityEmailHistoryPreviewModalLocNames =
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}ButtonViewEmCat`
	| `${LocNameStart}ContentDefaultType`
	| `${LocNameStart}TitleEmailNotFound`
	| `${LocNameStart}ContentEmailDisclaimer`
	| `${LocNameStart}LabelFromName`
	| `${LocNameStart}LabelFromEmail`
	| `${LocNameStart}LabelSubject`
	| `${LocNameStart}LabelPlainTextBody`
	| `${LocNameStart}LabelHtmlBody`
	| `${LocNameStart}ContentEmailNotFound`
	| `${LocNameStart}ButtonClose`;

export const spCandidateSystemActivityEmailHistoryPreviewModalLocs: LocDefs<SPCandidateSystemActivityEmailHistoryPreviewModalLocNames> =
	{
		SPCandidateSystemActivityEmailHistoryPreviewModalTitleTab: {
			defaultValue: 'Enrollment',
			description: 'Tab Title',
			displayPath: `${pathStart}Tab Title`,
			displayType: 'Title',
			legacyName: 'OtherRequirement/Candidates.Enrollment.Title.Tab',
			...sharedProperties,
		},
		SPCandidateSystemActivityEmailHistoryPreviewModalButtonViewEmCat: {
			defaultValue: 'View Email Catalog',
			description: 'View Email Catalog button',
			displayPath: `${pathStart}View Email Catalog`,
			displayType: 'Button',
			legacyName: 'CandidateAccess/Candidates.EmailHistory.Button.ViewEmCat',
			...sharedProperties,
		},
		SPCandidateSystemActivityEmailHistoryPreviewModalContentDefaultType: {
			defaultValue: 'System',
			description: 'Default content type for the email preview dialog',
			displayPath: `${pathStart}System`,
			displayType: 'Content',
			legacyName: 'CandidateAccess/Candidates.EmailHistory.Content.DefaultType',
			...sharedProperties,
		},
		SPCandidateSystemActivityEmailHistoryPreviewModalTitleEmailNotFound: {
			defaultValue: 'Email Not Found',
			description: 'Email Not Found title',
			displayPath: `${pathStart}Email Not Found`,
			displayType: 'Title',
			legacyName: 'CandidateAccess/Candidates.EmailHistory.Title.EmailNotFound',
			...sharedProperties,
		},
		SPCandidateSystemActivityEmailHistoryPreviewModalContentEmailDisclaimer: {
			defaultValue:
				'The following is the current English email text. This text may be different from the email sent to the candidate.',
			description: 'Email disclaimer',
			displayPath: `${pathStart}Email disclaimer`,
			displayType: 'Content',
			legacyName: 'CandidateAccess/Candidates.EmailHistory.Content.EmailDisclaimer',
			...sharedProperties,
		},
		SPCandidateSystemActivityEmailHistoryPreviewModalLabelFromName: {
			defaultValue: 'From Name',
			description: 'Label for: From name.',
			displayPath: `${pathStart}From Name`,
			displayType: 'Label',
			legacyName: 'CandidateAccess/Candidates.EmailHistory.FieldLabel.FromLabel',
			...sharedProperties,
		},
		SPCandidateSystemActivityEmailHistoryPreviewModalLabelFromEmail: {
			defaultValue: 'From Email Address',
			description: 'Label for: From Email Address.',
			displayPath: `${pathStart}From Email Address`,
			displayType: 'Label',
			legacyName: 'CandidateAccess/Candidates.EmailHistory.FieldLabel.FromEmail',
			...sharedProperties,
		},
		SPCandidateSystemActivityEmailHistoryPreviewModalLabelSubject: {
			defaultValue: 'Subject',
			description: 'Label for: Subject.',
			displayPath: `${pathStart}Subject`,
			displayType: 'Label',
			legacyName: 'CandidateAccess/Candidates.EmailHistory.FieldLabel.Subject',
			...sharedProperties,
		},
		SPCandidateSystemActivityEmailHistoryPreviewModalLabelPlainTextBody: {
			defaultValue: 'Body',
			description: 'Label for: Plain Text Body.',
			displayPath: `${pathStart}Plain Text Body`,
			displayType: 'Label',
			legacyName: 'CandidateAccess/Candidates.EmailHistory.FieldLabel.PlainBody',
			...sharedProperties,
		},
		SPCandidateSystemActivityEmailHistoryPreviewModalLabelHtmlBody: {
			defaultValue: 'Body',
			description: 'Label for: HTML Body.',
			displayPath: `${pathStart}HTML Body`,
			displayType: 'Label',
			legacyName: 'CandidateAccess/Candidates.EmailHistory.FieldLabel.HTMLBody',
			...sharedProperties,
		},
		SPCandidateSystemActivityEmailHistoryPreviewModalContentEmailNotFound: {
			defaultValue: 'There was a problem loading this email',
			description: 'Message shown when the email cannot be loaded',
			displayPath: `${pathStart}Email Loading Problem`,
			displayType: 'Content',
			legacyName: 'CandidateAccess/Candidates.EmailHistory.Content.EmailNotFound',
			...sharedProperties,
		},
		SPCandidateSystemActivityEmailHistoryPreviewModalButtonClose: {
			defaultValue: 'Close',
			description: 'Close button',
			displayPath: `${pathStart}Close`,
			displayType: 'Button',
			legacyName: 'CandidateAccess/Candidates.EmailHistory.Button.Close',
			...sharedProperties,
		},
	};

export type SPCandidateSystemActivityEmailHistoryPreviewModalLocType =
	LocMap<SPCandidateSystemActivityEmailHistoryPreviewModalLocNames>;
